// @flow
import * as React from 'react';
import pipe from 'ramda/es/pipe';
import toPairs from 'ramda/es/toPairs';
import forEach from 'ramda/es/forEach';
import curry from 'ramda/es/curry';


/**
* Применяет заданный объект стилей к HTML элементу
*/
export const applyStyles = curry((elem: React.ElementRef<any>, styles: Object) => pipe(
  toPairs,
  forEach(([p, s]) => {
    elem.style[p] = s; // eslint-disable-line no-param-reassign
  }),
)(styles));

export const nill = null;
